import { Tooltip, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';

export default function PdfPrintButton({ divRef, name }: { divRef: React.MutableRefObject<HTMLDivElement | null>; name: string }) {
    return (
        <ReactToPrint
            trigger={() => (
                <Tooltip title={`Print ${name}`}>
                    <Button variant="outlined" startIcon={<PrintIcon />}>
                        Print {name}
                    </Button>
                </Tooltip>
            )}
            content={() => divRef.current}
        />
    );
}
